@if (!mappedItem?.isFromManualPurchaseOrder) {
    <button
        mat-icon-button
        [disabled]="mappedItem?.isControlledByParentLot || mappedItem?.allRulesFalse"
        [matMenuTriggerFor]="nonManualMenu"
    >
        <mat-icon svgIcon="dots-horizontal"></mat-icon>
    </button>
    <mat-menu #nonManualMenu>
        @if (permissions.canViewPoHistory) {
            <button mat-menu-item (click)="viewHistory(mappedItem)">
                <mat-icon>history</mat-icon>
                View History
            </button>
        }

        <!-- Edit SSR Activity -->
        @if (mappedItem.ssrId && !downloadOnly && permissions.canEditActivity) {
            <button
                mat-menu-item
                [disabled]="!mappedItem?.rules?.canEditActivity"
                (click)="editActivity()"
            >
                <mat-icon svgIcon="pencil"></mat-icon>
                Edit Activity
            </button>
        }
        <!-- Edit Non SSR Activity -->
        @if (!mappedItem.ssrId && !downloadOnly && permissions.canEditActivity) {
            <button
                mat-menu-item
                [disabled]="!mappedItem?.rules?.canEditActivity"
                (click)="editBuildProgrammeActivity()"
            >
                <mat-icon svgIcon="pencil"></mat-icon>
                Edit Activity
            </button>
        }
        @if (!downloadOnly && permissions.canGenerateSSR) {
            <button
                mat-menu-item
                [disabled]="!mappedItem?.rules?.canGenerateSsr"
                (click)="createSsr()"
            >
                <mat-icon svgIcon="content-copy"></mat-icon>
                Generate SSR
            </button>
        }
        @if (!downloadOnly && permissions.canSetSupplier) {
            <button
                mat-menu-item
                [disabled]="!mappedItem?.rules?.canSetSupplier"
                (click)="setSupplier()"
            >
                <mat-icon svgIcon="pencil"></mat-icon>
                Set Supplier
            </button>
        }
        @if (permissions.canDownloadPO) {
            <button
                mat-menu-item
                [disabled]="!mappedItem?.rules?.canDownloadPO"
                (click)="mappedItem?.downloadPo()"
            >
                <mat-icon svgIcon="file-download"></mat-icon>
                Download PO
            </button>
        }
        @if (permissions.canDownloadSSR) {
            <button
                mat-menu-item
                [disabled]="!mappedItem?.rules?.canDownloadSsr"
                (click)="mappedItem?.downloadSsr()"
            >
                <mat-icon svgIcon="file-download"></mat-icon>
                Download SSR
            </button>
        }
        @if (!downloadOnly && permissions.canSplitSSR) {
            <button
                mat-menu-item
                [disabled]="!mappedItem?.rules?.canSplitActivity"
                (click)="splitActivity()"
            >
                <mat-icon svgIcon="call-split"></mat-icon>
                Split Activity
            </button>
        }
        @if (!downloadOnly && permissions.canAbandonSSR) {
            <button
                mat-menu-item
                [disabled]="!mappedItem?.rules?.canAbandon"
                (click)="setToAbandoned()"
            >
                <mat-icon svgIcon="cancel"></mat-icon>
                Abandon
            </button>
        }
        @if (!downloadOnly) {
            <button
                mat-menu-item
                [disabled]="
                    !mappedItem?.rules?.canRedraftSsr &&
                    !mappedItem?.rules?.canConfirmSsr &&
                    !mappedItem?.rules?.canCompleteSsr &&
                    !mappedItem?.rules?.canCancelSsr
                "
                [matMenuTriggerFor]="ssrStateMenu"
            >
                <mat-icon svgIcon="chart-timeline-variant"></mat-icon>
                Status
            </button>
        }
        <mat-menu #ssrStateMenu>
            @if (permissions.canRedraftSSR) {
                <button
                    mat-menu-item
                    [disabled]="!mappedItem?.rules?.canRedraftSsr"
                    (click)="redraftSsr()"
                >
                    <mat-icon svgIcon="undo"></mat-icon>
                    Redraft
                </button>
            }
            @if (permissions.canConfirmSSR) {
                <span
                    class="menu-tooltip-wrapper"
                    [matTooltip]="getCostActionDisabledText()"
                    [matTooltipDisabled]="!isCostActionDisabled()"
                    matTooltipPosition="right"
                >
                  <button
                      mat-menu-item
                      [disabled]="!mappedItem?.rules?.canConfirmSsr || isCostActionDisabled()"
                      (click)="confirmSsr()"
                  >
                    <mat-icon svgIcon="circle"></mat-icon>
                    <span>Confirm</span>
                  </button>
                </span>
            }
            @if (permissions.canCompleteSSR) {
                @if (mappedItem.activity.code == BUILD_COMPLETE_ACTIVITY_CODE) {
                    <button
                        mat-menu-item
                        [disabled]="mappedItem.statusId != BUILD_PROGRAMME_ACTIVITY_STATUS_ENUM.Confirmed"
                        (click)="submitSSrForApproval()"
                    >
                        <mat-icon svgIcon="circle"></mat-icon>
                        Submit for Approval
                    </button>
                } @else {
                    <button
                        mat-menu-item
                        [disabled]="!mappedItem?.rules?.canCompleteSsr"
                        (click)="completeSsr()"
                    >
                        <mat-icon svgIcon="circle"></mat-icon>
                        Complete
                    </button>
                }
            }

            @if (permissions.canCancelSSR) {
                <button
                    mat-menu-item
                    [disabled]="!mappedItem?.rules?.canCancelSsr"
                    (click)="cancelSsr()"
                >
                    <mat-icon svgIcon="cancel"></mat-icon>
                    Cancel
                </button>
            }
        </mat-menu>
        @if (!downloadOnly) {
            <button
                mat-menu-item
                [disabled]="!mappedItem?.rules?.canConvertToManualOrder"
                (click)="convertToManualOrder()"
            >
                <mat-icon svgIcon="swap-horizontal-variant"></mat-icon>
                Convert to Manual Order
            </button>
        }
        @if (!downloadOnly && toggleControlData.value.showButton) {
            <button
                mat-menu-item
                [disabled]="!toggleControlData.value.enableButton"
                (click)="toggleControl()"
            >
                <mat-icon [svgIcon]="toggleControlData.value.icon"></mat-icon>
                {{ toggleControlData.value.buttonLabel }}
            </button>
        }
    </mat-menu>
}
@if (mappedItem?.isFromManualPurchaseOrder) {
    <button
        mat-icon-button
        [disabled]="mappedItem?.isControlledByParentLot || mappedItem?.allRulesFalse"
        [matMenuTriggerFor]="manualMenu"
    >
        <mat-icon svgIcon="dots-horizontal"></mat-icon>
    </button>
    <mat-menu #manualMenu>
        @if (permissions.canViewPoHistory) {
            <button mat-menu-item (click)="viewHistory(mappedItem)">
                <mat-icon>history</mat-icon>
                View History
            </button>
        }
        @if (!downloadOnly && permissions.canEditActivity) {
            <button
                mat-menu-item
                [disabled]="!mappedItem?.rules?.canEditActivity"
                (click)="editBuildProgrammeActivity()"
            >
                <mat-icon svgIcon="pencil"></mat-icon>
                Edit Activity
            </button>
        }
        @if (!downloadOnly && permissions.canSetSupplier) {
            <button
                mat-menu-item
                [disabled]="
                    !mappedItem?.rules?.canSetSupplier ||
                    (mappedItem.manualOrderStatusId !== 2 &&
                        mappedItem.manualOrderStatusId !== 5) ||
                    !mappedItem.isTransformedToManualOrder
                "
                (click)="setSupplier()"
            >
                <mat-icon svgIcon="pencil"></mat-icon>
                Set Supplier
            </button>
        }
        @if (permissions.canViewManualOrder) {
            <button mat-menu-item (click)="viewManualOrder()">
                <mat-icon svgIcon="card-search"></mat-icon>
                View Manual Order
            </button>
        }
        @if (!downloadOnly) {
            @if (permissions.canEditActivity) {
                <button
                    mat-menu-item
                    [disabled]="!mappedItem?.rules?.canRedraftSsr"
                    (click)="redraftManualOrder()"
                >
                    <mat-icon svgIcon="undo"></mat-icon>
                    Redraft
                </button>
            }
            @if (permissions.canSplitSSR) {
                <button
                    mat-menu-item
                    [disabled]="!mappedItem?.rules?.canSplitActivity"
                    (click)="splitActivity()"
                >
                    <mat-icon svgIcon="call-split"></mat-icon>
                    Split Activity
                </button>
            }
            @if (!mappedItem.isTransformedToManualOrder && permissions.canAbandonManualOrder) {
                <button
                    mat-menu-item
                    [disabled]="!mappedItem?.rules?.canAbandon"
                    (click)="setToAbandoned()"
                >
                    <mat-icon svgIcon="cancel"></mat-icon>
                    Abandon
                </button>
            }
            @if (mappedItem.isTransformedToManualOrder && permissions.canCancelSSR) {
                <button
                    mat-menu-item
                    [disabled]="!mappedItem?.rules?.canCancelSsr"
                    (click)="setToAbandoned(true)"
                >
                    <mat-icon svgIcon="cancel"></mat-icon>
                    Cancel
                </button>
            }

            @if (mappedItem.activity.code == BUILD_COMPLETE_ACTIVITY_CODE) {
                <button
                    mat-menu-item
                    [disabled]="mappedItem.statusId != BUILD_PROGRAMME_ACTIVITY_STATUS_ENUM.Confirmed"
                    (click)="submitManualOrderForApproval()"
                >
                    <mat-icon svgIcon="circle"></mat-icon>
                    Submit for Approval
                </button>
            } @else {
                <button
                    mat-menu-item
                    [disabled]="!mappedItem?.rules?.canCompleteSsr"
                    (click)="completeManualOrder()"
                >
                    <mat-icon svgIcon="circle"></mat-icon>
                    Complete
                </button>
            }
        }
    </mat-menu>
}
